export default __webpack_public_path__ + "static/media/Mango.8f4327e5.png";